import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_NRDAY_75: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_NRDAY_75_N,
  },
  {
    pageId: PageId.CHAT_UPSELL_NRDAY_75,
  },
  {
    pageId: PageId.UPSELL_NRDAY_75,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_NRDAY_75,
  },
]
